import {DRAWER_CLOSE} from "./drawerTypes";

export const drawerOpenClose = (response) => {
  //console.log("dev action", response);
  return {
    type: DRAWER_CLOSE,
    payload: response,
  };
};